// features/Vault/hooks/useVaultHydration.ts
import { useEffect } from 'react'

import { coerceVaultCacheToArray } from '../vault.helpers'

type Args = {
  vaultKey: string
  getVaultMedia: (k: string) => any
  setMedia: (arr: any[]) => void
  setIsHydrated: (v: boolean) => void
}

export function useVaultHydration({ vaultKey, getVaultMedia, setMedia, setIsHydrated }: Args) {
  useEffect(() => {
    const cached = getVaultMedia(vaultKey)
    const arr = coerceVaultCacheToArray(cached)
    if (arr.length) {
      setMedia(arr)
      setIsHydrated(true)
    }
  }, [vaultKey, getVaultMedia, setMedia, setIsHydrated])
}
